module.exports = __webpack_public_path__ + "img/38.d52bd746.jpg";